import { Box, Typography } from "@mui/material";
import { TooltipProps } from "recharts";

const TOOLTIP_COLORS: Record<string, string> = {
  Confirmadas: "#4361EE",
  "Primeira parcela": "#06D6A0",
};

export const CustomTooltipInstallments = ({
  active,
  payload,
  label,
}: TooltipProps<number, string>) => {
  if (!active || !payload?.length) return null;

  return (
    <Box
      sx={{
        background: "#fff",
        border: "1px solid #E5E7EB",
        borderRadius: "10px",
        padding: "10px 14px",
        boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
        minWidth: 160,
      }}
    >
      <Typography
        sx={{ fontSize: "0.75rem", color: "#9CA3AF", mb: 0.5, fontWeight: 500 }}
      >
        {label}
      </Typography>

      {payload.map((entry) => (
        <Box
          key={entry.name}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            py: 0.3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor:
                  TOOLTIP_COLORS[entry.name || ""] || entry.color,
              }}
            />
            <Typography sx={{ fontSize: "0.8rem", color: "#374151" }}>
              {entry.name}
            </Typography>
          </Box>

          <Typography
            sx={{
              fontSize: "0.85rem",
              fontWeight: 700,
              color: TOOLTIP_COLORS[entry.name || ""] || entry.color,
            }}
          >
            {entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
